module.exports = __webpack_public_path__ + "img/yun_icu_logo.7d2e0b18.png";